import { useEffect, useRef, useState } from 'react'
import { fetchAuthBlob } from '@/shared/api'

/**
 * Hook to load an image via authenticated fetch and return a blob URL.
 * Automatically revokes previous blob URLs on cleanup.
 */
export function useAuthImage(imagePath: string | null): string | null {
  const [blobUrl, setBlobUrl] = useState<string | null>(null)
  const blobUrlRef = useRef<string | null>(null)

  useEffect(() => {
    if (!imagePath) {
      setBlobUrl(null)
      return
    }

    let cancelled = false
    void fetchAuthBlob(imagePath).then((url) => {
      if (cancelled || !url) return
      // Revoke previous blob URL if exists
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current)
      }
      blobUrlRef.current = url
      setBlobUrl(url)
    })

    return () => {
      cancelled = true
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current)
        blobUrlRef.current = null
      }
    }
  }, [imagePath])

  return blobUrl
}
